import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "../../locales/en.json";
import sv from "../../locales/sv.json";
import pt from "../../locales/pt.json";
import es from "../../locales/es.json";
import invoicePublicPt from "../../locales/invoice-public-pt.json";
import invoicePublicEs from "../../locales/invoice-public-es.json";
import { DOCUMENTATION_GUIDE_STRINGS } from "../../documentation/documentationGuideStrings";

// Get the saved language from localStorage or default to 'sv' (Swedish)
let savedLanguage = "sv";
try {
  savedLanguage = localStorage.getItem("language") || "sv";
} catch (error) {
  // Handle cases where localStorage might not be available (e.g., private browsing)
  console.warn("Failed to read language preference from localStorage:", error);
  savedLanguage = "sv";
}

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: { ...en, ...DOCUMENTATION_GUIDE_STRINGS.en } },
    sv: { translation: { ...sv, ...DOCUMENTATION_GUIDE_STRINGS.sv } },
    pt: { translation: { ...pt, ...invoicePublicPt, ...DOCUMENTATION_GUIDE_STRINGS.pt } },
    es: { translation: { ...es, ...invoicePublicEs, ...DOCUMENTATION_GUIDE_STRINGS.es } },
  },
  lng: savedLanguage, // Set the initial language
  fallbackLng: "en", // Fallback language
  supportedLngs: ["en", "sv", "pt", "es"],
  nonExplicitSupportedLngs: true,
  load: "languageOnly",
  interpolation: {
    escapeValue: false, // React already escapes values
  },
});

export default i18n;